import { IconButton } from '@mui/material';
import { Box, styled } from '@sb/cc-design-system';

export const SizeAccordionWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${theme.palette.divider};
  border-radius: 8px;
`,
);

export const ProductHeader = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 56px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.text.primary};
  background: ${theme.palette.grey[100]};
  border-radius: 8px 8px 0 0;
`,
);

export const ImageSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 12px 12px;
`;

export const ShowImageRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ImagePreview = styled('img')(
  ({ theme }) => `
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border: 1px solid ${theme.palette.divider};
  border-radius: 8px;
  margin-top: 4px;
`,
);

export const SizeHeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ImageAccordionWrapper = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.divider};
`,
);

export const FlavorRow = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 12px 8px 40px;
  min-height: 56px;
  border-top: 1px solid ${theme.palette.divider};
  background-color: transparent;
  width: 100%;

  & .AccordionItemLabel {
    flex: 1 1 auto;
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 400;
  }
`,
);

export const StyledFlavorRight = styled(Box)`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const FlavorDragHandle = styled(IconButton)(
  ({ theme }) => `
  padding: 0;
  cursor: grab;
  color: ${theme.palette.text.secondary};
`,
);
